import Vue from 'vue';

import 'quasar/dist/quasar.css';
import '@quasar/extras/material-icons/material-icons.css';
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css';

import Quasar, {
  QLayout,
  QHeader,
  QDrawer,
  QPageContainer,
  QPage,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QIcon,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QCard,
  QCardSection,
  QCardActions,
  QInput,
  QSelect,
  QTable,
  QTd,
  QTr,
  QTh,
  QDialog,
  QBadge,
  QChip,
  QForm,
  QCheckbox,
  QSpace,
  QSpinner,
  QTooltip,
  QCarousel,
  QCarouselSlide,
  QToggle,
  QExpansionItem,
  QScrollArea,
  QAvatar,
  QMenu,
  QSeparator,
  QFile,
  QBreadcrumbs,
  QBreadcrumbsEl,
  QTabs,
  QTab,
  QTabPanels,
  QTabPanel,
  QLinearProgress,
  Notify,
  Dialog
} from 'quasar';

Vue.use(Quasar, {
  config: {
    notify: {
      position: 'top-right',
      timeout: 3000
    }
  },
  components: {
    QLayout,
    QHeader,
    QDrawer,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QCard,
    QCardSection,
    QCardActions,
    QInput,
    QSelect,
    QTable,
    QTd,
    QTr,
    QTh,
    QDialog,
    QBadge,
    QChip,
    QForm,
    QCheckbox,
    QSpace,
    QSpinner,
    QTooltip,
    QCarousel,
    QCarouselSlide,
    QToggle,
    QExpansionItem,
    QScrollArea,
    QAvatar,
    QMenu,
    QSeparator,
    QFile,
    QBreadcrumbs,
    QBreadcrumbsEl,
    QTabs,
    QTab,
    QTabPanels,
    QTabPanel,
    QLinearProgress
  },
  plugins: {
    Notify,
    Dialog
  }
});
